import { PurchaseOrderReturnPanelModal } from './PurchaseOrderReturnPanelModal';

export default PurchaseOrderReturnPanelModal;
